import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

// 创建组队
export const createTeam = (teamName, windowIds) => {
  return api.post('/teams', {
    team_name: teamName,
    window_ids: windowIds
  })
}

// 获取用户的所有组队
export const getUserTeams = () => {
  return api.get('/teams')
}

// 获取组队详情
export const getTeamDetail = (teamId) => {
  return api.get(`/teams/${teamId}`)
}

// 删除组队
export const deleteTeam = (teamId) => {
  return api.delete(`/teams/${teamId}`)
}

// 更新组队名称
export const updateTeamName = (teamId, teamName) => {
  return api.put(`/teams/${teamId}`, {
    team_name: teamName
  })
}

// 添加窗口到队伍
export const addWindowToTeam = (teamId, windowId) => {
  return api.post(`/teams/${teamId}/windows`, {
    window_id: windowId
  })
}

// 从队伍中删除窗口
export const removeWindowFromTeam = (teamId, windowId) => {
  return api.delete(`/teams/${teamId}/windows/${windowId}`)
}

// 更新队伍状态
export const updateTeamStatus = (teamId, enabled, status, currentMap) => {
  return api.put(`/teams/${teamId}/status`, {
    enabled,
    status,
    current_map: currentMap
  })
}

// 更新窗口的备用名
export const updateWindowBakName = (teamId, windowId, bakName) => {
  return api.put(`/teams/${teamId}/windows/${windowId}/bak-name`, {
    bak_name: bakName
  })
}

// 更新队伍配置
export const updateTeamConfig = (teamId, config) => {
  return api.put(`/teams/${teamId}/config`, config)
}

